import { Link } from "react-router-dom";
import { Reveal, MaskText } from "@/components/Reveal";
import { WhyNoora } from "@/components/home/WhyNoora";
import { STORY_IMAGE, LIFESTYLE_BANNER } from "@/data/site";

const CHAPTERS = [
  {
    n: "01",
    title: "The Beginning",
    text: "Noora Jewels began with a simple belief: everyday jewelry should feel as considered as fine jewelry — without the fragility or the price tag. We set out to make pieces you could live in.",
  },
  {
    n: "02",
    title: "The Craft",
    text: "Every design is sealed with our proprietary anti-tarnish finish, engineered to resist water, sweat and daily wear. Skin-friendly, nickel-free, and made to hold its shine season after season.",
  },
  {
    n: "03",
    title: "The Promise",
    text: "Beautiful, effortless, and made to stay part of your story. Jewelry that stays with you — through every ordinary and extraordinary moment.",
  },
];

export default function About() {
  return (
    <div className="bg-ivory" data-testid="about-page">
      {/* Hero */}
      <section className="relative flex min-h-[70vh] items-center justify-center overflow-hidden px-6 text-center">
        <img src={LIFESTYLE_BANNER} alt="Noora" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/45" />
        <div className="relative z-10">
          <p className="eyebrow text-champagne">Our Story</p>
          <MaskText
            lines={["Made to Shine.", "Made to Last."]}
            className="mt-5 font-serif text-5xl font-light leading-[0.98] tracking-tight text-ivory md:text-8xl"
            delay={0.2}
          />
        </div>
      </section>

      {/* Manifesto chapters */}
      <section className="mx-auto max-w-[1100px] px-5 py-24 md:px-10 md:py-36">
        <div className="space-y-20 md:space-y-32">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} className="grid gap-8 md:grid-cols-[auto_1fr] md:gap-16">
              <span className="font-serif text-6xl font-light text-gold/50 md:text-8xl">{c.n}</span>
              <div>
                <h2 className="font-serif text-4xl font-light tracking-tight text-ink md:text-6xl">{c.title}</h2>
                <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink/70">{c.text}</p>
                {i === 0 && (
                  <img src={STORY_IMAGE} alt="" className="mt-10 aspect-[16/9] w-full rounded-2xl object-cover" />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <WhyNoora />

      <section className="px-5 py-24 text-center md:px-10 md:py-32">
        <Reveal>
          <h2 className="mx-auto max-w-2xl font-serif text-4xl font-light tracking-tight text-ink md:text-6xl">
            Ready to find your everyday shine?
          </h2>
          <Link
            to="/shop"
            className="mt-10 inline-block rounded-full bg-ink px-10 py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ivory transition-colors hover:bg-gold"
            data-testid="about-shop"
          >
            Shop the Collection
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
